import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { SPSSPAState, SPSSPADispatch } from './store';

export const useSPSSPADispatch = (): SPSSPADispatch =>
  useDispatch<SPSSPADispatch>();
export const useSPSSPASelector: TypedUseSelectorHook<SPSSPAState> = useSelector;
